// extracted by mini-css-extract-plugin
export default {"setsList":"ClientSets_setsList__FITYq"};